import {
  ExternalBankAccount,
  ExternalBankAccountStatus,
  PaymentMethodCapability
} from "@wingspanhq/wingspan-api-sdk";

export const selectorExternalBankAccountDepositReady = (
  externalBankAccount: ExternalBankAccount
) =>
  (externalBankAccount.status === ExternalBankAccountStatus.VERIFIED ||
    externalBankAccount.status === ExternalBankAccountStatus.PENDING) &&
  !!externalBankAccount.capabilities?.includes(PaymentMethodCapability.CHARGE);
